<div class="settings-modal-content">
  <h2 class="my-4 mat-h2">Treatment Uses</h2>
  <div>
    <app-treatment-item [TData]="newTreatmentUseData"></app-treatment-item>
    <button
      mat-flat-button
      color="primary"
      (click)="add()"
      [disabled]="!addAvailable()"
    >
      <span>Add</span>
    </button>
  </div>
  <div *ngIf="getTreatmentUses().length > 0">
    <h3 class="my-4">Existing uses</h3>
    <div *ngFor="let use of getTreatmentUses()">
      <app-treatment-item [TData]="use" [handleDelete]="remove.bind(this)">
      </app-treatment-item>
    </div>
  </div>
</div>
